import { Box, Link } from '@mui/material';
import classNames from 'classnames';
import { useLocation } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import { LegacyFAIcon } from '~/legacy-components/LegacyFAIcon';
import {
  LegacyModuleNavigationItem,
  useLegacyModuleNavigation,
} from '~/legacy-components/LegacyNavigation';

import { useSxStyles } from './useStyles';

export const LegacyFooterMenu = () => {
  const sxStyles = useSxStyles();
  const { navigationItems, isActiveModulePath } = useLegacyModuleNavigation();
  const { pathname } = useLocation();

  const NavItemIcon = (props: { item: LegacyModuleNavigationItem }) => {
    const { item } = props;

    return item.faIcon ? (
      <LegacyFAIcon FAIcon={item.faIcon.toString()} />
    ) : (
      <>{item.customIcon}</>
    );
  };

  const NavItem = (props: { item: LegacyModuleNavigationItem }) => {
    const { item } = props;

    if (item.hidden) {
      return <></>;
    }

    const commonProps = {
      sx: sxStyles.item,
      className: classNames(
        item.disabled && 'disabled',
        isActiveModulePath(item.module, pathname) && 'active',
      ),
      title: item.title,
    };

    if (item.disabled) {
      return (
        <Box component={'span'} {...commonProps}>
          <NavItemIcon item={item} />
        </Box>
      );
    }

    if (item.href.startsWith('/v2')) {
      const toPath = item.href.substr(3);

      return (
        <Link
          {...commonProps}
          component={RouterLink}
          to={toPath}
          underline={'none'}
        >
          <NavItemIcon item={item} />
        </Link>
      );
    }

    return (
      <Link {...commonProps} href={item.href} underline={'none'}>
        <NavItemIcon item={item} />
      </Link>
    );
  };

  return (
    <Box sx={sxStyles.root}>
      {navigationItems.map((item, index) => {
        return <NavItem item={item} key={`menu-item-${index}`} />;
      })}
    </Box>
  );
};
